import { useScroll, useTransform } from 'framer-motion';

export const useParallaxTransition = () => {
  const { scrollYProgress } = useScroll();

  // CinematicHeader parallax values - Enhanced for more dramatic effect
  const headerY = useTransform(scrollYProgress, [0, 0.2, 0.4, 0.7, 1], [0, -50, -120, -200, -350]);
  const headerOpacity = useTransform(scrollYProgress, [0, 0.3, 0.6, 0.9, 1], [1, 0.95, 0.7, 0.4, 0.1]);
  const headerScale = useTransform(scrollYProgress, [0, 0.3, 0.6, 1], [1, 1.05, 1.12, 1.2]);

  // ScrollSequenceSection parallax values - Enhanced for complementary dramatic effect
  const sectionY = useTransform(scrollYProgress, [0, 0.15, 0.3, 0.6, 0.85, 1], [150, 100, 50, 0, -50, -100]);
  const sectionOpacity = useTransform(scrollYProgress, [0, 0.1, 0.25, 0.5, 0.8, 1], [0, 0.6, 0.9, 1, 1, 0.8]);
  const sectionScale = useTransform(scrollYProgress, [0, 0.2, 0.5, 0.8, 1], [0.9, 0.95, 1.05, 1.1, 1.15]);

  return {
    header: {
      y: headerY,
      opacity: headerOpacity,
      scale: headerScale
    },
    section: {
      y: sectionY,
      opacity: sectionOpacity,
      scale: sectionScale
    }
  };
};